export enum FILTER_TYPES {
  PAYMENT_SERVICES = 'PAYMENT_SERVICES',
  CHARGING_NETWORKS = 'CHARGING_NETWORKS',
}
